module.exports = __webpack_public_path__ + "static/media/ww_nyar2.19df0f52.gif";